/**
 * Abre o widget de chat de atendimento carregado no layout raiz
 * (`AtaliaChatConfig` ou `ChatwootConfig`, conforme o token configurado
 * para a plataforma).
 *
 * Retorna `false` quando nenhum widget está disponível (token ausente,
 * script ainda carregando ou bloqueado), para o chamador exibir um
 * fallback.
 */

interface AtaliaChatApi {
  open: () => void
}

interface ChatwootApi {
  toggle: (state?: 'open' | 'close') => void
}

type SupportChatWindow = Window & {
  AtaliaChat?: AtaliaChatApi
  $chatwoot?: ChatwootApi
}

export function openSupportChat(): boolean {
  if (typeof window === 'undefined') {
    return false
  }

  const { AtaliaChat, $chatwoot } = window as SupportChatWindow

  if (AtaliaChat) {
    AtaliaChat.open()
    return true
  }

  if ($chatwoot) {
    $chatwoot.toggle('open')
    return true
  }

  return false
}
